import type { InsightTone } from '@platform/core/types';

/** Тон чипа причини fishbone за вагою (прототип v4: висока — червонуватий, середня — бурштиновий, низька — нейтральний). */
export const WEIGHT_TONE: Readonly<Record<string, InsightTone>> = { High: 'bad', Medium: 'mixed', Low: 'neutral' };
